import { LatestNewsCarouselWebComponent } from './component/LatestNewsCarouselWebComponent';

export { LatestNewsCarouselWebComponent };
